import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Photography from "@/components/site/Photography";
import ReelMoments from "@/components/site/ReelMoments";
import Manifesto from "@/components/site/Manifesto";
import Enquiry from "@/components/site/Enquiry";
import Footer from "@/components/site/Footer";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";

export default function Home() {
  useEffect(() => {
    document.title = "Flyora Weddings — Cinematic Wedding Films · Kerala · Dubai · London";
  }, []);

  return (
    <div data-testid="home-page" className="relative bg-[#050505] text-[#FDFBF7]">
      <div className="grain-overlay" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <About />
        <Portfolio />
        <Photography />
        <ReelMoments />
        <Manifesto />
        <Enquiry />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
